export default __webpack_public_path__ + "static/media/Group9164.8dd49b1f.svg";